/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * @emails react-core
 * @flow
 */

import Helmet from "react-helmet";
import React, { useEffect } from "react";
import wlogo from "../../assets/images/workativ-fevicon.svg";
import { GatsbySeo } from "gatsby-plugin-next-seo";

// const defaultDescription =
//   "Best AI Chatbot with Process Automation for IT & HR Helpdesk | Digital Transformation of Employee Support | Workativ Assistant";

const defaultOgImage = wlogo;
// only provide alternate links to pages in languages where 95-100% of core content has been translated
// which is determined by status enum of 2

// const defaultPage = x => {
//     return canonicalUrl.replace(urlRoot, 'https://reactjs.org');
// };

// let windowUrl = window.location.pathname;
// if (typeof window !== 'undefined') {
//   windowUrl =  windowUrl();
// }
let windowUrl = typeof window !== "undefined" && window.location.pathname;

const TitleAndMetaTags = ({
  title,
  description,
  keywords,
  ogTitle,
  ogDescription,
  ogImage,
  schema,
  includeFavIcon,
  url,
  robots,
  googlebot,
  homepagrUrl,
}) => {
  // useEffect(() => {
  //   (function (d) {
  //     var js,
  //       id = "facebook-jssdk";
  //     if (d.getElementById(id)) {
  //       return;
  //     }
  //     js = d.createElement("script");
  //     js.id = id;
  //     js.async = true;
  //     js.src = "https://connect.facebook.net/es_LA/all.js";
  //     d.getElementsByTagName("head")[0].appendChild(js);
  //   })(document);
  // }, []);
  return (
    <>
      <Helmet title={title}>
        <meta charset="UTF-8" />
        <meta http-equiv="X-UA-Compatible" content="IE=edge,chrome=1" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <meta http-equiv="Content-Type" content="text/html; charset=utf-8" />
        <meta name="description" content={description} />
        <meta name="author" content="" />
        <title>{title}</title>
        <meta name="keywords" content={keywords.join(", ")} />
        <meta property="og:type" content="website" />
        {homepagrUrl ? (
          <meta
            name="google-site-verification"
            content="Ep2rcT5HYxKaeJfTVjMOR8k89MGxHL5mPyDT0o50oRc"
          />
        ) : null}
        {/* <meta property="og:url" content="https://workativ.com" />
        <meta property="og:site_name" content="workativ.com" /> */}
        {/* <meta property="og:image" content={`https://workativ.com${ogImage}`} />
        <meta property="og:description" content={ogDescription} /> */}
        {/* <meta name="twitter:card" content="summary" />
        <meta name="twitter:site" content="@workativ" />
        <meta name="twitter:title" content={title} />
        <meta name="twitter:description" content={description} /> */}
        {/* <meta name="twitter:image" content={`https://workativ.com${ogImage}`} /> */}
        {/* <meta
          name="twitter:image:src"
          content={`https://workativ.com${ogImage}`}
        /> */}
        <meta name="twitter:site" content="@workativ" />
        <meta name="twitter:title" content={title} />
        <meta name="twitter:description" content={description} />
        <meta property="og:site_name" content="workativ.com" />
        <meta property="og:url" content={`https://workativ.com${windowUrl}`} />
        <meta property="og:title" content={title} />
        <meta property="og:description" content={description} />
        <meta property="og:image" content={`https://workativ.com${ogImage}`} />
        <meta name="robots" content={robots} />
        <meta name="googlebot" content={googlebot} />
        <meta
          property="og:image:url"
          content={`https://workativ.com${ogImage}`}
        />

        <meta
          name="twitter:image:src"
          content={`https://workativ.com${ogImage}`}
        />
        <meta name="fb:app_id" content="103584927648559" />

        <meta
          property="og:image:secure_url"
          content={`https://workativ.com${ogImage}`}
        />

        <meta
          property="og:image:type"
          content={`https://workativ.com${ogImage}`}
        />

        {schema ? (
          <script className="structured-data-list" type="application/ld+json">
            {JSON.stringify(schema)}
          </script>
        ) : null}
        {includeFavIcon ? (
          <link rel="icon" href={wlogo} type="image/png"></link>
        ) : null}
        <link
          rel="preconnect"
          href="https://calendly.com/workativ/workativ-demo-clone"
        ></link>
        <link
          rel="prefetch"
          as="script"
          href="https://assets.calendly.com/assets/external/widget.js"
        ></link>
      </Helmet>
      <GatsbySeo
        title={title}
        description={description}
        canonical={url}
        openGraph={{
          url: "https://workativ.com",
          title: `${title}`,
          description: `${description}`,
          image: `https://workativ.com${ogImage}`,
          images: [
            {
              url: `https://workativ.com${ogImage}`,
              width: 640,
              height: 400,
            },
          ],
          site_name: "Workativ",
        }}
      />
    </>
  );
};

export const HeadWithDataUri = ({
  title,
  description,
  keywords,
  ogTitle,
  ogDescription,
  ogImage,
  schema,
  includeFavIcon,
  url,
}) => {
  // console.log("HeadWithDataUri", url)
  return (
    <Helmet title={title}>
      <meta charset="UTF-8" />
      <meta http-equiv="X-UA-Compatible" content="IE=edge" />
      <meta name="viewport" content="width=device-width, initial-scale=1" />
      <meta content="text/html; charset=UTF-8" name="Content-Type" />
      <meta name="description" content={description} />
      <meta name="author" content="" />
      <title>{title}</title>
      <meta name="keywords" content={keywords.join(", ")} />
      <meta property="og:title" content={ogTitle} />
      <meta property="og:type" content="website" />
      <meta property="og:url" content={url} />
      <meta property="og:site_name" content="workativ.com" />
      <meta property="og:image" content={ogImage} />
      <meta property="og:description" content={ogDescription} />
      <meta name="twitter:card" content="summary" />
      <meta name="twitter:site" content="@workativ" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage} />
      <meta property="og:image:width" content="640" />
      <meta property="og:image:height" content="442" />
      <link rel="canonical" key={url} href={url}></link>

      {schema ? (
        <script className="structured-data-list" type="application/ld+json">
          {JSON.stringify(schema)}
        </script>
      ) : null}
      {includeFavIcon ? (
        <link rel="icon" href={wlogo} type="image/png"></link>
      ) : null}
    </Helmet>
  );
};

export default TitleAndMetaTags;
